define(['components/utilities/utilities', 'libs/hoverIntent'], function (utils, hoverIntent) {
	'use strict';

	/**
	 * Dropdown
	 * A plugin for handeling dropdowns (with accessibility features).
	 * @exports dropdown
	 */
	var dropdown = {

		/** Delay settings for hoverIntent. */
		hoverIntentOptions: {
			timeout: 200,
			interval: 100
		},


		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			this._initDropdown();
		},


		/**
		 * Initiates dropdown functionality
		 * @private
		 */
		_initDropdown: function () {
			var that = this;

			utils.forEachElement('.has-dropdown', function (el) {
				el._dropdownTarget = el.querySelector('.dropdown');
				if (el._dropdownTarget !== undefined) {
					if (!Modernizr.touchevents) {
						that._initiateHoverIntent(el);
						that._initKeyboardNavigation(el);
					} else {
						that._initTouchHover(el);
					}
				}
			});
		},


		/**
		 * Initiates hoverIntent functionality
		 * @param {Object} el - The DOM object to add featue to.
		 * @private
		 */
		_initiateHoverIntent: function (el) {
			hoverIntent(el,
				function () {
					this._dropdownTarget.setAttribute('aria-hidden', false);
				}, function () {
					this._dropdownTarget.setAttribute('aria-hidden', true);
				}
			).options(this.hoverIntentOptions);
		},


		/**
		 * Fixes so hover works on touch devices.
		 * @param {Object} el - The DOM object to add featue to.
		 * @private
		 */
		_initTouchHover: function (el) {
			var childLink = el.querySelector('a');

			utils.addEventListener(el, 'click', function () {
				if (el._dropdownTarget.getAttribute('aria-hidden') === 'true') {
					utils.forEachElement('.dropdown', function (dropdownEl) {
						dropdownEl.setAttribute('aria-hidden', true);
					});
					el._dropdownTarget.setAttribute('aria-hidden', false);
				} else {
					el._dropdownTarget.setAttribute('aria-hidden', true);
				}
			});

			if (childLink !== undefined) {
				utils.addEventListener(childLink, 'click', function (event) {
					if (el._dropdownTarget.getAttribute('aria-hidden') === 'true' || this.getAttribute('href') === '#') {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
					}
				});
			}
		},


		/**
		 * Add keyboard tab navigation.
		 * @param {Object} el - The DOM object to add featue to.
		 * @private
		 */
		_initKeyboardNavigation: function (el) {
			// Open dropdown on first enterpress (open link on second)
			utils.addEventListener(el, 'keydown', function (event) {
				if (event.keyCode === 13 && this._dropdownTarget.getAttribute('aria-hidden') === 'true') {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
					var input = this._dropdownTarget.querySelectorAll('input')[0];
					this._dropdownTarget.setAttribute('aria-hidden', false);

					if (input !== undefined) {
						input.focus();
					}
				}
			});

			// Close dropdown on focus leave
			utils.addEventListener(el, 'blur', function () {
				el._focusoutTimer = setTimeout(function () {
					el._dropdownTarget.setAttribute('aria-hidden', true);
				}, 50);
			});

			utils.addEventListener(el, 'focus', function () {
				if (el._focusoutTimer !== undefined) {
					clearTimeout(el._focusoutTimer);
				}
			});
		}
	};


	return dropdown;
});


//////////////////
// WEBPACK FOOTER
// ./components/dropdown/dropdown.js
// module id = 6
// module chunks = 0